var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Document",
    "data-name": "Iconly/Bold/Document",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M13.191,0C16.28,0,18,1.78,18,4.83h0V15.16c0,3.1-1.72,4.84-4.809,4.84H4.81C1.77,20,0,18.26,0,15.16H0V4.83C0,1.78,1.77,0,4.81,0h8.381ZM5.08,13.74a.784.784,0,0,0-.75.37.8.8,0,0,0,0,.84.777.777,0,0,0,.75.36h7.84a.79.79,0,0,0,0-1.57H5.08Zm7.84-4.561H5.08a.781.781,0,0,0,0,1.561h7.84a.781.781,0,0,0,0-1.561ZM8.069,4.65H5.08v.01a.78.78,0,0,0,0,1.56H8.069a.785.785,0,0,0,0-1.57Z",
    fill: "#1a365d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.2fe4f480d7281a833933e1e13624476e.svg";
export { ForwardRef as ReactComponent };